// extracted by mini-css-extract-plugin
module.exports = {"Slide":"Slide_Slide__c2k5I"};